import { useMemo, useState } from 'react';
import { PrimaryButton, RichTextEditor, SecondaryButton } from '@lib/common';
import { Space } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpace = styled(Space).withConfig({
  displayName: "comment-boxcomponent__StyledSpace",
  componentId: "sc-155iid4-0"
})(["width:100%;display:flex;justify-content:space-between;color:black;"]);
var StyledButtonSpace = styled(Space).withConfig({
  displayName: "comment-boxcomponent__StyledButtonSpace",
  componentId: "sc-155iid4-1"
})(["width:100%;display:flex;justify-content:end;"]);
export var CommentBox = function CommentBox(_ref) {
  var label = _ref.label,
      onSave = _ref.onSave,
      value = _ref.value,
      onCancel = _ref.onCancel,
      loading = _ref.loading;

  var _useState = useState(value),
      textValue = _useState[0],
      setTextValue = _useState[1];

  var handleOnSave = function handleOnSave() {
    onSave(textValue);
  };

  var handleOnChange = function handleOnChange(e) {
    setTextValue(e);
  };

  var isSavingDisabled = useMemo(function () {
    if (!value) {
      var isTextValueEmpty = textValue === '<p></p>' || textValue === '<p><br></p>';

      if (isTextValueEmpty) {
        return true;
      }
    }

    return textValue === value;
  }, [textValue, value]);
  var editorLabels = {
    addColumnBefore: label.addColumnBefore,
    addColumnAfter: label.addColumnAfter,
    deleteColumn: label.deleteColumn,
    addRowBefore: label.addRowBefore,
    addRowAfter: label.addRowAfter,
    deleteRow: label.deleteRow,
    deleteTable: label.deleteTable,
    mergeCells: label.mergeCells,
    splitCell: label.splitCell,
    basicColors: label.basicColors,
    bold: label.bold,
    italic: label.italic,
    moreFormatting: label.moreFormatting,
    underline: label.underline,
    strike: label.strike,
    alignLeft: label.alignLeft,
    alignCenter: label.alignCenter,
    alignRight: label.alignRight,
    bulletList: label.bulletList,
    orderedList: label.orderedList,
    textStyles: label.textStyles,
    table: label.table,
    addImage: label.addImage,
    textColor: label.textColor,
    column: label.column,
    row: label.row,
    cellColor: label.cellColor,
    addAudio: label.addAudio,
    addMath: label.addMath,
    justify: label.justify
  };
  return /*#__PURE__*/_jsxs(StyledSpace, {
    size: 'small',
    direction: "vertical",
    children: [/*#__PURE__*/_jsx(RichTextEditor, {
      placeholder: label.placeholder,
      content: textValue,
      onChange: handleOnChange,
      editorLabels: editorLabels,
      disabled: loading,
      scrollable: true
    }), /*#__PURE__*/_jsxs(StyledButtonSpace, {
      align: "baseline",
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancel,
        disabled: loading,
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        onClick: handleOnSave,
        disabled: isSavingDisabled,
        loading: loading,
        children: label.save
      })]
    })]
  });
};